export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Reposted-Green-349eddf2dec7970e2bb44db9a4f85aab.svg";